// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { PhotoMetaSummary, IPhotoMetaSummary } from "./PhotoMetaSummary.gen";

export interface IPhotoMetaSearchResult {
	data: IPhotoMetaSummary[] | undefined;

	hasMore: boolean;

	nextCursor: string | undefined;

	count: number;

	$type?: string | undefined;
}
export class PhotoMetaSearchResult {
	constructor(data?: IPhotoMetaSearchResult) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		this.data = data.data ? data.data.map((d: any) => new PhotoMetaSummary(d)) : [];
	}

	data: PhotoMetaSummary[] | undefined = [];

	hasMore: boolean = false;

	nextCursor: string | undefined;

	count: number = 0;

	static $type: string = "CoreApi.Models.PhotoMetaSearchResult, ";
	$type?: string | undefined = PhotoMetaSearchResult.$type;
}

